import React from "react"
import PropTypes from "prop-types"
import { ClipLoader } from "react-spinners"
import styled from "styled-components"
import { SpinnerColor } from "../../utils/enumUtil"
import { isUndefinedNullOrEmpty } from "../../utils/common"

export const LoaderWrapper = styled.div`
  height: ${props =>
    !isUndefinedNullOrEmpty(props.height) && props.isFixedHeight === false
      ? `calc(100vh - ${props.height}px)`
      : !isUndefinedNullOrEmpty(props.height) && props.isFixedHeight === true
      ? `${props.height}px`
      : "100vh"};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0;
  overflow-y: auto;
  width: 100%;
`

class Loader extends React.Component {
  render() {
    const {
      isLoading,
      size,
      isFallback,
      fallbackComponent,
      children,
      height,
      isFixedHeight,
    } = this.props
    return isLoading ? (
      <LoaderWrapper height={height} isFixedHeight={isFixedHeight}>
        <ClipLoader
          color={SpinnerColor.Green}
          size={size || 45}
          loading={true}
        />
      </LoaderWrapper>
    ) : isFallback ? (
      fallbackComponent
    ) : (
      children
    )
  }
}

Loader.defaultProps = {
  loaderType: "circle",
  isFallback: false,
  isLoading: false,
  isFixedHeight: false,
  fallbackComponent: <span>No Data Available</span>,
}

Loader.propTypes = {
  height: PropTypes.string,
  size: PropTypes.number,
  isLoading: PropTypes.bool,
  isFallback: PropTypes.bool,
  fallbackComponent: PropTypes.node,
  loaderType: PropTypes.string, // liner || overlay || circle
}
export default Loader
